import React from 'react';
import { Loader2, AlertTriangle } from 'lucide-react';
import { useWorld } from '../../contexts/WorldDataContext';
import type { WorldData } from '../../types/world';

/** Muestra el contenido solo cuando los datos del servidor están cargados. */
export function WorldGate({
  children
}: {
  children: (w: WorldData) => React.ReactNode;
}) {
  const world = useWorld();
  if (world.status === 'ready' && world.data) return <>{children(world.data)}</>;
  if (world.status === 'error') {
    return <div role="alert" className="flex items-start gap-3 rounded-2xl border border-red-400/30 bg-red-500/[0.06] p-5" data-id="element-2527" data-mp="2fhqx5nqdjo2">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-red-300" aria-hidden="true" data-id="element-2528" data-mp="3tnceha4zprpm" />
        <div data-id="element-2529" data-mp="3plihpcxx17uq">
          <p className="font-semibold text-white" data-id="element-2530" data-mp="3pm0jsq79egak">No pudimos cargar los datos de mapas e ítems.</p>
          <p className="mt-1 text-sm text-gray-400" data-id="element-2531" data-mp="3kkb8rak1e2mh">{world.error}</p>
          <button type="button" onClick={world.ensure} className="mt-3 inline-flex h-10 items-center rounded-full border border-white/15 px-4 text-sm font-semibold text-white transition-colors duration-150 hover:border-[#D4AF37]/50" data-id="element-2532" data-mp="3flzywztqrs49">
            Reintentar
          </button>
        </div>
      </div>;
  }
  return <div role="status" className="space-y-3" data-id="element-2533" data-mp="16sii0szoz92t">
      <p className="flex items-center gap-2 text-sm text-gray-400" data-id="element-2534" data-mp="16pmi4z4aaabq">
        <Loader2 className="h-4 w-4 animate-spin text-[#D4AF37]" aria-hidden="true" data-id="element-2535" data-mp="1br23yteackv6" />
        Cargando datos del servidor…
      </p>
      {[0, 1, 2].map(i => <div key={i} className="h-20 animate-pulse rounded-2xl bg-white/[0.04]" data-id="element-2536" data-mp="23i88dm11h4q9" />)}
    </div>;
}